import { Pipe, PipeTransform, inject } from '@angular/core';
import { ResizePipe } from './resize.pipe';
import { ImageProcessorConfig } from '../models';

@Pipe({
  name: 'resizeHtmlImages',
  standalone: true,
})
export class ResizeHtmlImagesPipe implements PipeTransform {
  // Inherited from CSS: $grid-breakpoints
  // is used to generate size attribute with collspans
  cssBreakPoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  };
  private config = inject(ImageProcessorConfig);
  private resize = new ResizePipe();

  constructor() {}

  transform(
    htmlContent: string,
    width: number = 1000,
    format: 'jpg' | 'png' | 'bmp' | 'gif' | 'webp' = 'webp',
    imageSizes: number[] = [600, 800, 900, 1200, 1600, 1920]
  ): any {
    if (!htmlContent) {
      return htmlContent;
    }

    const queryParams = `?width=${width}&format=${format}&quality=80&scale=both`;

    // htmlContent = htmlContent.replace(
    //   /(<img src=")([^"]+)"/g,
    //   (match, p1, p2) => `${p1}${p2}${queryParams}"`
    // );

    htmlContent = htmlContent.replace(/(<img src=")([^"]+)"/g, (match, p1, p2) => {
      // console.log(p2);

      const imgParams = this.resize.transform(p2, width, undefined, undefined, undefined, format, 'both', undefined);
      const srcSet = this.generateSrcSet(p2, imageSizes, format);
      return `${p1}${imgParams}" srcset="${srcSet}"`;
    });

    return htmlContent;
  }

  // private generateSrcSet(baseUrl: string, sizes: number[], format: string): string {
  //   return sizes.map(size => `${baseUrl}?width=${size}&format=${format}&quality=80&scale=both ${size}w`).join(', ');
  // }
  private generateSrcSet(baseUrl: string, sizes: number[], format: 'jpg' | 'png' | 'bmp' | 'gif' | 'webp'): string {
    return sizes
      .map(size => {
        // Gebruik `this.resize.transform` voor elke URL
        const resizedUrl = this.resize.transform(baseUrl, size, undefined, undefined, undefined, format, 'both', undefined);
        return `${resizedUrl} ${size}w`;
      })
      .join(', ');
  }
}
